<template>

	<div>
		<modal :show="show" @close="close">
<h1>Modal Elements</h1>
		</modal><!-- /.modal --> 
	</div>
</template>

<script>
    import Modal from './Modal';
    export default {
        props: ['show'],
        components: { Modal },
        methods: {
            close: function() {
                this.$emit('close')
            }
        }
    }
</script>
